export class WlmNavKeys {
  static Home = 'home';
  static LeakageCalculationModule = 'leakage-calculation';
  static DistributionNetwork = 'distribution-network';
  static TransmissionNetwork = 'transmission-network';
  static PressureMonitoring = 'pressure-monitoring';
  static AlcModule = 'alc';
  static Prioritisation = 'prioritisation';
  static ActivityRaising = 'activity-raising';
  static Activities = 'activities';
  static Leaks = 'leaks';
  static Campaigns = 'campaigns';
  static AdministrationModule = 'administration';
  static Users = 'users';
  static Groups = 'groups';
  static ConfigurationModule = 'configuration';
  static TelemetryPoints = 'telemetry-points';
  static WaterBalanceModule = 'water-balance-module';
  static WaterBalance = 'water-balance';
  static DataAccessModule = 'data-access-module';
  static DataVisualization = 'data-visualization';
  static AlarmsConfiguration = 'alarms-configuration';
  static AlarmsCreationTelemetry = 'alarm-creation-telemetry';
  static AlarmsCreationAlgorithms = 'alarm-creation-algorithm';
  static AlarmsCreation = 'alarm-creation';
  static MonitoringModule = 'monitoring-module';
  static Notifications = 'notifications';
  static NetworkElementConfig = 'ne-config';
  static NetworkElementDetails = 'ne-config-details';
  static LeakageReporting = 'leakage-reporting';
  static Algorithms = 'algorithms-configuration';
  static PressureManagementModule = 'pressure-module';
  static BiModule = 'bi-module';
  static Bi = 'bi';
  static Map = 'map';
  static Hierarchy = 'hierarchy';
  static CustomerDetails = 'customer-details';
  static BIHome = 'bi-home';
  static UoM = 'uom';
  static Schematics = 'schematics';
  static LogsModule = 'logs-module';
  static LogsInterfaces = 'logs-interfaces';
  static LogsSystem = 'logs-system';
  static Audits = 'audits';
  static DataValidation = 'data-validation';
  static Calendar = 'calendars';
  static MergedZones = 'merged-zones';
  static Integration = 'integration';
}
